import { ReactNode } from "react";
type TailwindClass = string & {}; 
export function LayoutContainer({children, className}:{children: ReactNode, className?: TailwindClass}) {
  return (
    <div className={`max-w-[95%] md:w-[65%] sm:max-w-[100%] h-full flex justify-center items-center mx-auto ${className}`}>
      {children}
    </div>
  );
}
